import { useActions, useNostoAppState } from "@nosto/search-js/preact/hooks"
import { useState } from "preact/hooks"
import { nostojs } from "@nosto/nosto-js"
import Button from "@/elements/Button/Button"
import styles from "./NoResults.module.css"

const SUGGESTED_LINKS = [
  { label: "Shop by brand", href: "https://www.dlttrading.com/shop-all-brands" },
  { label: "Shop newest arrivals", href: "https://www.dlttrading.com/newest-arrivals" },
  { label: "Shop exclusives", href: "https://www.dlttrading.com/dlt-trading-exclusives" }
]

export default function NoResults() {
  const query = useNostoAppState(state => state.response?.query)
  const { newSearch } = useActions()
  const [newQuery, setNewQuery] = useState("")

  function onSubmit(event: Event) {
    event.preventDefault()
    if (!newQuery.trim()) {
      return
    }
    nostojs(api => api.recordSearchSubmit(newQuery))
    newSearch({ query: newQuery })
  }

  return (
    <div className={styles.container}>
      <p className={styles.message}>Sorry, we couldn&apos;t find any results for &quot;{query}&quot;</p>
      <p className={styles.suggestionsTitle}>Here are a few suggestions to get you what you want to see</p>
      <ul className={styles.suggestionsList}>
        <li>Check your spelling</li>
        <li>Try a broader search</li>
      </ul>
      <nav className={styles.links} aria-label="Suggested pages">
        {SUGGESTED_LINKS.map(link => (
          <a key={link.label} className={styles.link} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>
      <form className={styles.searchAgainForm} onSubmit={onSubmit}>
        <input
          type="text"
          className={styles.searchAgainInput}
          aria-label="Search again"
          value={newQuery}
          onInput={event => setNewQuery(event.currentTarget.value)}
        />
        <Button type="submit" className={styles.searchAgainButton}>
          Search again
        </Button>
      </form>
    </div>
  )
}
